// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowDown16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-down': IconArrowDown;
    }
}

/**
 * The icon component for the 'arrowDown' icon
 */
export class IconArrowDown extends Icon {
    public constructor() {
        super(arrowDown16X16);
    }
}

registerIcon('icon-arrow-down', IconArrowDown);
export const iconArrowDownTag = 'nimble-icon-arrow-down';
